import React, { useEffect, useRef } from 'react'
import * as classes from './Slogan.module.scss'
import cn from 'classnames'
import { useDataSlogan } from './useDataSlogan'
import { useDataSloganByEn } from './useDataSloganByEn'
import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'

gsap.registerPlugin(ScrollTrigger, CSSRulePlugin)

function Slogan({ lang }) {
    const dataByHy = useDataSlogan()
    const dataByEn = useDataSloganByEn()

    const data = lang === 'hy' ? dataByHy : dataByEn
    const heroImage = data.heroImage?.image?.url
    const imageRef = useRef(null)
    const borderTopRef = useRef(null)
    const borderRightRef = useRef(null)
    const borderBottomRef = useRef(null)
    const borderLeftRef = useRef(null)

    useEffect(() => {
        const wrap = document.querySelector('.slogan-text')
        let timer = false

        if (wrap) {
            const lineOne = wrap.firstElementChild.querySelector('u')
            const lineTwo = wrap.lastElementChild.querySelector('u')

            if (lineOne && lineTwo) {
                lineOne.classList.add('slogan-lineOne')
                lineTwo.classList.add('slogan-lineTwo')
            }

            timer = setTimeout(() => {
                gsap.to(imageRef.current, {
                    duration: 1.4,
                    opacity: 1,
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: 'top 75%'
                    }
                })

                gsap.to(wrap.firstElementChild, {
                    duration: 0.77,
                    delay: 0.9,
                    x: 0,
                    opacity: 1,
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: 'top 95%'
                    }
                })

                gsap.to(wrap.lastElementChild, {
                    duration: 0.77,
                    delay: 0.9,
                    x: 0,
                    opacity: 1,
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: 'top 95%'
                    }
                })

                gsap.to(CSSRulePlugin.getRule(`.slogan-lineOne::after`), {
                    duration: 0.5,
                    delay: 1.5,
                    opacity: 1,
                    width: '100%',
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: 'top 95%'
                    }
                })

                gsap.to(CSSRulePlugin.getRule(`.slogan-lineTwo::after`), {
                    duration: 0.5,
                    delay: 1.9,
                    opacity: 1,
                    width: '100%',
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: 'top 95%'
                    }
                })

                gsap.to(borderTopRef.current, {
                    duration: 0.3,
                    delay: 1.9,
                    width: '100%',
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: 'top 95%'
                    }
                })

                gsap.to(borderRightRef.current, {
                    duration: 0.3,
                    delay: 2.2,
                    height: '100%',
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: 'top 95%'
                    }
                })

                gsap.to(borderBottomRef.current, {
                    duration: 0.3,
                    delay: 2.5,
                    width: '100%',
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: 'top 95%'
                    }
                })

                gsap.to(borderLeftRef.current, {
                    duration: 0.3,
                    delay: 2.8,
                    height: '100%',
                    ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    scrollTrigger: {
                        trigger: imageRef.current,
                        start: 'top 95%'
                    }
                })
            }, 1500)
        }

        return () => {
            if (timer) {
                clearTimeout(timer)
            }
        }
    }, [])

    if (data?.title?.value) {
        const titlePlainText = data.title.value.replace(/<\/?h2[^>]*>/gi, '').trim()
        const titleSplitIndex = titlePlainText.indexOf(' ')
        const titleFirstWord = titleSplitIndex === -1 ? titlePlainText : titlePlainText.slice(0, titleSplitIndex)
        const titleRest = titleSplitIndex === -1 ? '' : titlePlainText.slice(titleSplitIndex + 1)

        return (
            <section className={cn(classes.Section, { [classes.LangHY]: lang === 'hy' })}>
                <div className={classes.Inner}>
                    <div className={classes.Image} style={heroImage ? { backgroundImage: `url(${heroImage})` } : undefined} ref={imageRef} />

                        {titlePlainText ? (
                            <div className={classes.Text + ' slogan-text '}>
                                <h2>{titleFirstWord}</h2>
                                {titleRest ? <h2>{titleRest}</h2> : null}
                            </div>
                        ) : null}
                    </div>
            </section>
        )
    } else {
        return (
            <div>
                <br/>
                <br/>
                <br/>
            </div>
        )
    }
}

export default Slogan
